// extracted by mini-css-extract-plugin
export var container = "GiftValuePanel-module__container___TxxKS";
export var headerAndSubText = "GiftValuePanel-module__headerAndSubText___PlrCU";
export var subHeadAndSubText = "GiftValuePanel-module__subHeadAndSubText___z4CIa";
export var imageA = "GiftValuePanel-module__imageA___qINRX";
export var imageC = "GiftValuePanel-module__imageC___y__kA";
export var largeImage = "GiftValuePanel-module__largeImage___mgMvU";
export var header = "GiftValuePanel-module__header___nt9Tt";
export var perfectForAllContainer = "GiftValuePanel-module__perfectForAllContainer___H5RSV";
export var andMore = "GiftValuePanel-module__andMore___bdfVd";
export var subText = "GiftValuePanel-module__subText___P9PGN";
export var subHeader = "GiftValuePanel-module__subHeader___q_LQD";
export var imageGrid = "GiftValuePanel-module__imageGrid___g1mgs";
export var leftImageColumn = "GiftValuePanel-module__leftImageColumn___eO5fn";
export var subImages = "GiftValuePanel-module__subImages___Ot_H9";
export var athleteList = "GiftValuePanel-module__athleteList___HO67A";
export var imageAndBlurbs = "GiftValuePanel-module__imageAndBlurbs___kfZ_F";
export var gc = "GiftValuePanel-module__gc___tVHH6";
export var blurbs = "GiftValuePanel-module__blurbs___yneZI";
export var rightImageColumn = "GiftValuePanel-module__rightImageColumn___VvP1W";